import { render } from "./ImageCropper.vue?vue&type=template&id=fa4807be&scoped=true"
import script from "./ImageCropper.vue?vue&type=script&lang=js"
export * from "./ImageCropper.vue?vue&type=script&lang=js"

import "./ImageCropper.vue?vue&type=style&index=0&id=fa4807be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa4807be"]])

export default __exports__